<mat-toolbar color="primary">
  <button mat-icon-button color="white" class="" (click)="toggleRightSidenav()" type="button">
    <mat-icon>menu</mat-icon>
  </button>
  <span class="mat-title mb-0">ShopNearby.me Console</span><span class="mat-caption mb-0"> v1.6</span>
  <span class="fill-remaining-space"></span>

</mat-toolbar>